const OVERLAY_ONETIMESAVING = "onetimesaving";
const OVERLAY_RECURRINGSAVING = "recurringsaving";
const OVERLAY_ONETIMEINCOME = "onetimeincome";
const OVERLAY_RECURRINGINCOME = "recurringincome";

const METHOD_SNOWBALL = "debtsnowball";
const METHOD_SNOWBALLTWO = "debtsnowballtwo";
const METHOD_AVALANCHE = "debtavalanche";
const METHOD_FREELANCE = "debtfreelance";

const PRINCIPAL_REMAINING = "principal";
const TOTAL_INTEREST_PAID = "interest";
const MONTHLY_PAYMENT = "monthlypayment";
const PERCENT_TOWARD_PRINCIPAL = "percenttowordprincipal";

const LOANS_CHART_TYPES = [
  PRINCIPAL_REMAINING,
  TOTAL_INTEREST_PAID,
  MONTHLY_PAYMENT,
  PERCENT_TOWARD_PRINCIPAL
];

module.exports = {
  OVERLAY_ONETIMESAVING,
  OVERLAY_RECURRINGSAVING,
  OVERLAY_ONETIMEINCOME,
  OVERLAY_RECURRINGINCOME,
  METHOD_SNOWBALL,
  METHOD_SNOWBALLTWO,
  METHOD_AVALANCHE,
  METHOD_FREELANCE,
  LOANS_CHART_TYPES,
  PRINCIPAL_REMAINING,
  TOTAL_INTEREST_PAID,
  MONTHLY_PAYMENT,
  PERCENT_TOWARD_PRINCIPAL
};
